/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Writepermission1Inputs */

const de__field_writepermission1 = /** @type {(inputs: _Field_Writepermission1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schreibrechte`)
};

/**

* @param {_Field_Writepermission1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_writepermission1 = /** @type {((inputs?: _Field_Writepermission1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Writepermission1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_writepermission1(inputs)
});
export { _field_writepermission1 as "_field_writePermission" }